
import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../../provider/CommonContext";
import { Col, Container, Row } from 'react-bootstrap';
import { format, parseISO } from 'date-fns';
import './Buybacklist.css';
import Pagination from '../../../CommonUI/Pagination/Pagination';
import CorporateActOption from "../../CorporateActOption/CorporateActOption";
import CallTrackApi from "../../../Activity_Track/CallTrackApi";

function Buybacklist() {
    const [data, setData] = useState([]);
    const [dataGroup, setDataGroup] = useState([]);
    const [corptype, settype] = useState('BuyBack');
    const [currentPage, setCurrentPage] = useState(1);
    const { BaseURL } = useContext(URLstateContext);
    let getData, getDataGroup, eleBtn, eleBtnLoose, eleLi;
    let PageSize = 8;

    useEffect(() => {
        window.scrollTo(0, 0)
        // if (groupValue === "BSE") {
        const getUrl = BaseURL + "CorporateAction";
        fetch(`${getUrl}/${corptype}/-/-/-/-`)
            .then((response) => response.json())
            .then((data) => {
                getData = data.data;
                setData(getData);

                // console.log(getData, "getData")
            })
            .catch((error) => {
            });

        const getUrlGroup = BaseURL + "GroupMaster";
        fetch(`${getUrlGroup}`)
            .then((response) => response.json())
            .then((dataG) => {
                getDataGroup = dataG.data;
                setDataGroup(getDataGroup);
                // console.log(getDataGroup, "getDataGroup")
            })
            .catch((error) => {
            });

    }, []);

    const currentTableData = useMemo(() => {
        if (data != null && data != []) {
            const firstPageIndex = (currentPage - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;
            if (data != null && data != []) {
                if (data.length > 0) {
                    return data.slice(firstPageIndex, lastPageIndex);
                }
            }
        }
    }, [currentPage, data]);
    CallTrackApi("Buyback List",window.location.href);

    return (
        <>
         <div class="col-12 p-0 breadcrum ">
                <ul>
                    <li><a href="/">Home</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li><a href="/market/stocks">Stocks</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li>BuyBack List</li>
                </ul>
            </div>
            <Container>
                <Row>
                    <Col sm={12}>
                        <section className='Buyblk-loser-sc'>
                            <div className='Buyblk-header'>
                                <h2><span>BuyBack List</span></h2>
                            </div>

                            <CorporateActOption optionCorp="BuyBack List" />
                            <div className='Buyblk-table table-responsive'>
                                <table className='table'>
                                    <thead>
                                        <tr>
                                            <th className='text-left'>Name</th>
                                            <th className='text-right'>Buyback Price</th>
                                            <th className='text-left'>Buyback Type</th>
                                            <th className='text-right'>Board Meeting Date</th>
                                            <th className='text-right'>Open Date</th>
                                            <th className='text-right'>Close Date</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentTableData && currentTableData.map(
                                            ({ co_name, maxbuybackprice, offertype, AnnouncementDate, BBFromdate, BBToDate }) => (
                                                <tr>
                                                    <td className="text-left">{co_name}</td>
                                                    <td className="text-right">{maxbuybackprice}</td>
                                                    <td className="text-left">{offertype}</td>
                                                    <td className="text-right">{(AnnouncementDate != null) ? (format(parseISO(AnnouncementDate), 'dd-MMM-yyyy')) : ''}</td>
                                                    <td className="text-right">{(BBFromdate != null) ? (format(parseISO(BBFromdate), 'dd-MMM-yyyy')) : ''}</td>
                                                    <td className="text-right">{(BBToDate != null) ? (format(parseISO(BBToDate), 'dd-MMM-yyyy')) : ''}</td>



                                                </tr>
                                            ))}
                                    </tbody>
                                </table>
                            </div>
                            {(data != null && data != []) ?
                                <Pagination
                                    className="pagination-bar_peer"
                                    currentPage={currentPage}
                                    totalCount={(data.length != null) ? data.length : 0}
                                    pageSize={PageSize}
                                    onPageChange={page => setCurrentPage(page)}
                                /> : <p className="errorPeer"> No Data Found !!! </p>}

                        </section>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default Buybacklist;
